import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { Subject } from 'rxjs/Rx';
import { ProductExcelComponent } from '../../../../common/helper/evs/product/product.excel.component';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import { ExportService } from '../../../../common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';
import { StampStatisticsService } from '../statistics/StampStatistics.service';
import * as moment from 'moment';
declare var $: any;

@Component({
  moduleId: module.id,
  // tslint:disable-next-line:component-selector
  selector: 'evs_product_list',
  templateUrl: './product-list-detail.component.html',
  styleUrls: ['./product_list.css'],
  providers: [ConfirmationService, EvsProductService, StampStatisticsService],
})
@Injectable()
export class EvsProductListComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage: number = 1;
  public totalRow: number = 0;
  public page_size: number = 10;
  public offset: number = 0;
  public pager: any = {};
  public products: any = [];
  public message: { class: string; content: string } = null;
  public error: string = '';
  public files: any = null;
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public msgs: Message[] = [];
  public paramsQuery: any = {};
  loading_data = true;

  public current_filter: any = {};

  public item_active: any = 0;
  public item_detail: any = {};
  loadingDetail: boolean = false;

  public arr_sort = { name: null };
  isAdd: Boolean = false;
  isUpdate: Boolean = false;
  isSetting: Boolean = false;

  vendorDetail: any = {};
  infoDetail: any = [];

  sort: any = {
    field: '',
    typeSort: '',
  };
  cities: any = [];
  districts: any = [];
  isChangeStatus: Boolean = false;
  videoUrl: any;
  totalItem: any = 0;
  totalPage: any = 0;

  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  filesAttachName: any = [];
  fakeFilesAttachName: any = [];
  stasitic: any;
  /* Tuanba:12/4/2022: Mekongas*/
  source = Number(JSON.parse(localStorage.getItem('User')).source);
  sourceFrom: number;
  isShowVariant: boolean = false;

  // === Tab chung ===
  activeTab: number = 1;
  warningFilter: any = {};
  warningPage_Size: any = 8;

  // === Tab Cảnh báo sản phẩm hết hạn ===
  warningsUseTime: any = [];
  totalWarningPageUseTime: any = 0;
  currentPageUseTime: any = 1;
  productId4: any = null;

  // === Tab nhắc nhở ===
  listAlertRepeatTime: any = [];
  listDayAgo: any = [1, 2, 3, 4, 5, 6, 7];
  totalWarningPageRepeatTime: any = 0;
  currentPageRepeatTime: any = 1;
  productId5: any = null;
  @ViewChild('importFile') importFile: ModalDirective;
  @ViewChild('importUpdateFile') importUpdateFile: ModalDirective;

  constructor(
    private _location: Location,
    private productService: EvsProductService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private evsAddressService: EvsAddressService,
    public upload: UploadEvsService,
    private exportService: ExportService,
    private translate: TranslateService,
    private statisticService: StampStatisticsService
  ) {
  }

  ngOnInit() {
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    this.titleFileUpdate = this.translate.instant('PS_CHON_FILE_UPLOAD');
    this.initSelect2();
    this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
      if (!this.files || this.files.length === 0) {
        this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
        this.titleFileUpdate = this.translate.instant('PS_CHON_FILE_UPLOAD');
      }
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (this.isEmpty(params)) {
        this.model.name = params.productName ? params.productName : '';
        this.model.display_name = params.productName ? params.productName : '';
        this.current_filter.name = params.productName ? params.productName : '';
        this.sort.field = 'created_time';
        this.sort.typeSort = 'desc';
        this.loadData(this.current_filter, this.sort);
      }
    });

    this.getCity();
    $('[data-toggle="tooltip"]').tooltip();
    $('#inputStart').datepicker({ format: 'dd-mm-yyyy' });
    $('#inputEnd').datepicker({ format: 'dd-mm-yyyy' });
    $('.input-daterange').datepicker();
    // this.clearDataForm();
    // this.routerChange = this.activatedRoute.queryParams.subscribe((params: Params) => {
    //     this.loadData(true, this.paramsQuery);
    // });
    this.sort.field = 'created_time';
    this.sort.typeSort = 'desc';
    this.loadData(this.current_filter, this.sort);
    this.getStasitic();
  }

  initSelect2() {
    this.translate.get('CHON_TRANG_THAI').subscribe((res: string) => {
      $('#status').select2({
        placeholder: res,
        allowClear: true,
        minimumResultsForSearch: Infinity,
      });
    });
  }

  getStasitic() {
    let data_get = {};
    // let data_get: any = datafilter ? datafilter : this.current_filter;

    // if (this.currentPage < 0) {
    //   this.currentPage = 1;
    // }
    // data_get.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    // data_get.limit = this.page_size;
    // data_get.sort_by = sort.field + ':' + sort.typeSort;
    this.productService.getProductStasitic(data_get).subscribe((res) => {
      if (!res.error) {
        this.stasitic = res.data;
      }
    });
  }

  isEmpty(obj) {
    return Object.keys(obj).length !== 0;
  }

  filterClick(type, filterForm: NgForm) {
    switch (type) {
      case 'total_product': {
        this.resetForm(filterForm);
        break;
      }
      case 'total_show': {
        let status = $('#status');
        status.val('').trigger('change');
        filterForm.reset();
        status.val(1).trigger('change');
        this.onSubmit();
        break;
      }
      case 'total_hide': {
        let status = $('#status');
        status.val('').trigger('change');
        filterForm.reset();
        status.val(0).trigger('change');
        this.onSubmit();
        break;
      }
    }
  }

  uploadExcel() {
    this.componentData = {
      component: ProductExcelComponent,
      inputs: {
        size: 'modal-md',
      },
    };
  }

  loadData(datafilter: any = {}, sort: any = {}) {
    console.log('source11231321', this.source);
    this.loading_data = true;
    let data_get: any = datafilter ? datafilter : this.current_filter;
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;
    data_get.sort_by = sort.field + ':' + sort.typeSort;
    // this.productService.getProductStasitic(data_get)
    //   .subscribe(res => {
    //     if (!res.error) {
    //       this.stasitic = res.data;
    //     }
    //   })
    this.productService
      .getAllProduct(data_get)
      .toPromise()
      .then((res) => {
        this.loading_data = false;
        if (res.status == 200 && !res.error) {
          this.totalRow = res.data.total;
          this.products = res.data.products;
          // for (let i = 0; i < this.products.length; i++) {
          //   this.products[i].image = this.imageService.readSrcImage(
          //     this.products[i].image,
          //     "thumb_medium"
          //   );
          // }
          this.totalItem = res.data.count.count;
          var pageString = (this.totalItem / this.page_size).toString();
          var pageSplit = pageString.split('.');
          var last: any;
          var totalpage = parseInt(pageSplit[0]);
          if (pageSplit.length > 1) {
            last = pageSplit[1];
            if (parseInt(last) > 0) {
              totalpage++;
            }
          }
          this.totalPage = totalpage;
          //this.item_detail = this.products[0];
          this.viewDetail(this.products[this.item_active], this.item_active);
          //this.setPage(this.currentPage);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.status + ' : ' + res.message,
          };
          this.products = [];
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        }
      })
      .catch((err: any) => {
        console.log(err);
        // if (err.status != 401) {
        // this.products = [];
        // $("html, body").animate({ scrollTop: 0 }, "slow");
        // this.message = {
        //   content: "Load data: " + err.message,
        //   class: "alert dark alert-danger",
        // };
        // }
      });
  }

  viewDetail(item: any, i) {
    this.filesAttachName = [];
    this.fakeFilesAttachName = [];
    if ($('#video')) {
      $('#video').remove();
    }
    this.infoDetail = [];
    this.loadingDetail = true;
    if (this.isAdd == true) {
      this.toastr.info(this.translate.instant('CANCEL_ADD_PRODUCT'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    if (this.isUpdate == true) {
      this.toastr.info(this.translate.instant('CANCEL_UPDATE_PRODUCT'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    if (this.isSetting == true) {
      this.toastr.info(this.translate.instant('CANCEL_SETTING'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    this.isAdd = false;
    this.isUpdate = false;
    this.isSetting = false;
    this.isShowVariant = false;
    this.item_active = i;

    this.productService
      .getDetaiById(item.id)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.item_detail = res.data;
          // Map warranty_reminder_config to flat variables
          const mapModeReverse = (mode: string) => mode === 'ONCE' ? 'once' : 'recurring';
          const mapUnitReverse = (unit: string) => unit === 'DAY' ? 'days' : (unit === 'MONTH' ? 'months' : 'years');

          if (this.item_detail.warranty_reminder_config) {
            const config = this.item_detail.warranty_reminder_config;
            if (config.reminderMaintain && config.reminderMaintain.isSelect) {
              this.item_detail.is_maintenance_reminder = true;
              this.item_detail.maintenance_mode = mapModeReverse(config.reminderMaintain.mode);
              this.item_detail.is_extend_maintenance = config.reminderMaintain.reminderContinue || false;
              this.item_detail.maintenance_cycle = config.reminderMaintain.numberTimeNotify;
              this.item_detail.maintenance_cycle_unit = mapUnitReverse(config.reminderMaintain.timeType);
              this.item_detail.extend_limit = config.reminderMaintain.numberOfLimit || null;
            } else {
              this.item_detail.is_maintenance_reminder = false;
            }

            if (config.reminderExpired && config.reminderExpired.isSelect) {
              this.item_detail.is_expired_reminder = true;
              this.item_detail.expired_mode = mapModeReverse(config.reminderExpired.mode);
              this.item_detail.expired_cycle = config.reminderExpired.numberTimeNotify;
              this.item_detail.expired_cycle_unit = mapUnitReverse(config.reminderExpired.timeType);
            } else {
              this.item_detail.is_expired_reminder = false;
            }
          }
          this.loadingDetail = false;
          this.vendorDetail = res.data.vendor;
          // this.infoDetail = res.data.infos;
          const copy = JSON.stringify(res.data.infos);
          this.infoDetail = JSON.parse(copy)
          console.log('tuan:', this.item_detail);
          this.sourceFrom = this.item_detail.source
          this.infoDetail.map(val => {
            if (val.content.indexOf('<p>') === -1 && val.content.indexOf('\n') !== -1) {
              val.content = '<p>' + val.content;
              val.content = val.content.replace(/\n/g, '</p>\n<p>')
            }
          });
          // Convert string br
          // this.infoDetail.map((val) => {
          //   if (val.content.indexOf("\n") !== -1) {
          //     val.content = val.content.replace(/\n\n/g, "<br>")
          //   }
          // })

          console.log('tung', res.data.infos);

          if (this.item_detail.images) {
            for (let i = 0; i < this.item_detail.images.length; i++) {
              this.item_detail.images[i] = this.item_detail.images[i].medium;
            }
          }
          this.filesAttachName = [];
          this.fakeFilesAttachName = [];
          if (
            this.item_detail.attachments &&
            this.item_detail.attachments.length > 0
          ) {
            this.item_detail.attachments.forEach((att) => {
              var show = '';
              if (att.length > 30) {
                show = '... ... ' + att.slice(att.length - 20, att.length);
              } else {
                show = att;
              }
              var item = {
                link: att,
                show: show,
                isAdd: false,
              };
              this.filesAttachName.push(item);
            });
          }
          if (
            this.item_detail.fake_attachments &&
            this.item_detail.fake_attachments.length > 0
          ) {
            this.item_detail.fake_attachments.forEach((att) => {
              var show = '';
              if (att.length > 30) {
                show = '... ... ' + att.slice(att.length - 20, att.length);
              } else {
                show = att;
              }
              var item = {
                link: att,
                show: show,
                isAdd: false,
              };
              this.fakeFilesAttachName.push(item);
            });
          }
          if (!this.item_detail.number_batches) {
            this.item_detail.number_batches = 0;
          }
          if (!this.item_detail.number_stamps) {
            this.item_detail.number_stamps = 0;
          }
          if (
            this.item_detail.video &&
            this.item_detail.video.indexOf('watch?v=') > 0
          ) {
            var url = this.item_detail.video.replace('watch?v=', 'embed/');
            this.videoUrl = url;

            if ($('#video')) {
              $('#video').remove();
            }
            $('#videoProduct').append(
              `<iframe id="video" width="261px" allowFullScreen  height="100%" type="text/html" src="` +
              url +
              `" style="display: inline-block" alt="Link video hỏng" allowfullscreen="true">
            </iframe>`
            );
          }
          if (this.isChangeStatus == true) {
            this.products[this.item_active].status = this.item_detail.status;
            if (!res.error) {
              if (this.products[this.item_active].status == 0) {
                this.toastr.warning(
                  this.translate.instant('PRODUCT_HIDDEN_WARNING'),
                  this.translate.instant('CANH_BAO'),
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  }
                );
              }
            }
          }
          this.isChangeStatus = false;
          if (this.vendorDetail) {
            var city = this.vendorDetail.city_id;
            if (this.cities.length > 0) {
              for (let i = 0; i < this.cities.length; i++) {
                if (city === this.cities[i].id) {
                  this.vendorDetail['city_name'] = this.cities[i].value;
                  this.loadDistrictData(this.cities[i].id);
                }
              }
            }
          }
        } else {
          console.log('error=true');
        }
      })
      .catch((err) => {
        console.log('catch:', err);
      });
  }

  setSort(field: string, typeSort: string) {
    this.sort.field = field;
    this.sort.typeSort = typeSort;
    this.loadData(null, this.sort);
  }

  resetForm(frm: NgForm) {
    $('#status').val('').trigger('change');
    frm.reset();
    this.sort.field = 'created_time';
    this.sort.typeSort = 'desc';
    this.onSubmit();
  }

  onSubmit() {
    console.log('this.sort', this.sort, $('#name').val())
    this.item_active = 0;
    this.isAdd = false;
    this.isUpdate = false;
    this.isSetting = false;
    const modelQuery = <any>{};
    if ($('#name').val()) {
      modelQuery.name = $('#name').val().toString();
    }
    if ($('#sku').val()) {
      modelQuery.sku = $('#sku').val().toString();
    }
    if ($('#display_name').val()) {
      modelQuery.display_name = $('#display_name').val().toString();
    }
    if ($('#internal_name').val()) {
      modelQuery.internal_name = $('#internal_name').val().toString();
    }
    // if ($('#inputStart').val()) {
    //   let start = $('#inputStart').val().toString();
    //   modelQuery.from = start;
    // }
    // if ($('#inputEnd').val()) {
    //   let end = $('#inputEnd').val().toString();
    //   modelQuery.to = end;
    // }
    if ($('#status').val()) {
      modelQuery.status = $('#status').val();
    }
    this.currentPage = 1;
    this.current_filter = modelQuery;
    // this.paramsQuery = modelQuery;
    // this.router.navigate([], {
    //     queryParams: this.paramsQuery
    // });

    this.loadData(modelQuery, this.sort);
  }

  searchByName(event, model?: any) {
    if (event.keyCode == 13) {
      if (this.model.name.trim().length > 0) {
        this.router.navigate([], {
          queryParams: this.model,
        });
      }
    }
  }

  search(event, mode?: any) {
    switch (mode) {
      case 'name':
        this.model.name = event;
        break;
      default:
        this.model.name = event;
        break;
    }
    this.router.navigate([], {
      queryParams: this.model,
    });
  }

  setPage(page: number) {
    this.item_active = 0;
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.sort);
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning(this.translate.instant('MAX_PAGE_MESSAGE') + ' ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.sort);
      }
    }
  }

  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery, this.sort);
    }
  }

  backToComponent() {
    this._location.back();
  }

  deletePro(id) {
    this.confirmationService.confirm({
      message: this.translate.instant('CONFIRM_DELETE_PRODUCT'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        this.productService.deleteProduct(id).subscribe((response) => {
          if (response) {
            let mEror = response.error;
            if (mEror === false) {
              // this.msgs = [{
              //   severity: 'success',
              //   summary: 'Thông báo',
              //   detail: 'Xóa sản phẩm thành công'
              // }];
              this.toastr.success(this.translate.instant('DELETE_PRODUCT_SUCCESS'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              // this.loadData(this.paramsQuery);
              this.loadData(null, this.sort);
            } else {
              // this.msgs = [{
              //   severity: 'error',
              //   summary: 'Thông báo',
              //   detail: 'Không thành công: ' + response.message
              // }];
              this.toastr.error(this.translate.instant('DELETE_PRODUCT_FAILED'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          }
        });
      },
    });
  }

  ChangeStatus(item) {
    this.products.find((product) => {
      if (product.sku == item.sku) {
        var status: any;
        if (this.item_detail.status == 0) {
          status = 1;
        } else if (this.item_detail.status == 1) {
          status = 0;
        }
        //console.log(status)
        var info: any = {
          status: status,
        };
        this.productService
          .updateStatusById(this.item_detail.id, info)
          .subscribe((res) => {
            if (!res.error) {
              this.isChangeStatus = true;
              this.viewDetail(this.item_detail, this.item_active);
            }
          });
      }
    });
  }

  back(event) {
    if (event['isBack'] == false) {
      //console.log(event);
      if (event['AddSuccess'] == true) {
        this.item_active = 0;
      }
      this.loadData(null, this.sort);
    }
    this.isAdd = false;
  }

  backUpdate(event) {
    if (event['isBack'] == false) {
      this.loadData(null, this.sort);
      this.getStasitic();
    }
    this.isUpdate = false;
    this.isSetting = false;
    this.isShowVariant = false;
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  getCity() {
    this.evsAddressService.getCities().subscribe((res) => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.evsAddressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
        var disctrict = this.vendorDetail.district_id;
        for (let i = 0; i < this.districts.length; i++) {
          if (disctrict === this.districts[i].id) {
            this.vendorDetail['district_name'] = this.districts[i].value;
          }
        }
      });
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  rotateIcon(eleID) {
    if ($('#' + eleID).attr('aria-expanded') == 'true') {
      $('#' + eleID).removeClass('is_open');
    } else if ($('#' + eleID).attr('aria-expanded') == 'false') {
      $('#' + eleID).addClass('is_open');
    } else {
      $('#' + eleID).addClass('is_open');
    }
  }

  //Import product
  openModalImportFile() {
    this.clearInputFile()
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.importFile.show();
  }

  closeModalImportFile() {
    this.importFile.hide();
  }

  public titleFile: string = '';
  public data_import_success: { class: string; content: string; } = null;
  public data_import_fail: { class: string; content: string; } = null;

  onChange(event) {
    console.log('event', event)
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  clearInputFile() {
    const input = $('#controlFile');
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }

  submitForm(data) {
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    console.log('this.files ', this.files)
    if (this.files !== null && this.files.length > 0) {
      var file = this.files[0];
      this.files = null;

      var file_name = file.name;
      var allowedExtensions = ['xlsx', 'xls', 'csv'];
      var fileExtension = file_name.split('.').pop();
      console.log('allowedExtensions', allowedExtensions)
      console.log('fileExtension', fileExtension)
      if (this.isInArray(allowedExtensions, fileExtension)) {
        //msg process
        this.message = {
          class: 'alert dark alert-success',
          content: this.translate.instant('DANG_THUC_HIEN')
        };
        //upload file
        this.upload.uploadFileProduct(file).then((res: any) => {
          if (res.code === 1) {

            this.data_import_success = {
              class: 'alert dark alert-icon alert-success',
              content: this.translate.instant('IMPORT_SUCCESS_COUNT') + res.data.success,
            }

            this.data_import_fail = {
              class: 'alert dark alert-icon alert-warning',
              content: this.translate.instant('IMPORT_FAILED_COUNT') + res.data.fail,
            }

            this.message = {
              class: 'alert dark alert-icon alert-success',
              content: this.translate.instant('IMPORT_PRODUCT_SUCCESS'),
            };
            setTimeout(() => {
              this.currentPage = 1;
              this.getStasitic();
              this.loadData(this.current_filter, this.sort);
            }, 1000);
          } else {
            this.message = {
              class: 'alert dark alert-icon alert-danger',
              content: res.message
            }
              ;
          }
        }, error => {
          this.message = {
            class: 'alert dark alert-icon alert-danger',
            content: error.message
          };
        });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: this.translate.instant('VUI_LONG_CHON_DUNG_FILE_EXCEL')
        };
      }
    } else {
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('BAN_CHUA_CHON_FILE_DE_IMPORT')
      };
    }
    this.clearInputFile()

  }

  //Import update product
  openModalImportUpdateFile() {
    this.clearInputUpdateFile()
    this.message = null;
    this.data_import_update_fail = null;
    this.data_import_success = null
    this.importUpdateFile.show();

  }

  closeModalImportUpdateFile() {
    this.clearInputUpdateFile()
    this.message = null;
    this.data_import_update_fail = null;
    this.data_import_success = null
    this.importUpdateFile.hide();
  }

  public titleFileUpdate: string = '';
  public data_import_update_success: { class: string; content: string; } = null;
  public data_import_update_fail: { class: string; content: string; } = null;

  onChangeUpdate(event) {
    console.log('event', event)
    this.files = event.target.files;
    console.log('this.files', this.files)
    if (this.files.length > 0) {
      this.titleFileUpdate = this.files[0].name;
    } else {
      this.titleFileUpdate = this.translate.instant('CHON_FILE_UPLOAD');
    }
  }


  clearInputUpdateFile() {
    const input = $('#controlFileUpdate');
    input.val(''); // Đặt giá trị input về rỗng
    input.trigger('change'); // Kích hoạt sự kiện change để Angular nhận diện
    this.files = null; // Xóa biến files
    this.titleFileUpdate = this.translate.instant('CHON_FILE_UPLOAD'); // Reset tiêu đề
  }

  submitFormUpdate(data) {
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    if (this.files !== null && this.files.length > 0) {
      const file = this.files[0];
      this.files = null;
      const file_name = file.name;
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      const fileExtension = file_name.split('.').pop();
      if (this.isInArray(allowedExtensions, fileExtension)) {
        this.message = {
          class: 'alert dark alert-success',
          content: this.translate.instant('DANG_THUC_HIEN')
        };
        this.upload.uploadFileUpdateProduct(file).then((res: any) => {
          if (res.code === 1) {

            this.data_import_update_success = {
              class: 'alert dark alert-icon alert-success',
              content: this.translate.instant('IMPORT_SUCCESS_COUNT') + res.data.success,
            }

            this.data_import_update_fail = {
              class: 'alert dark alert-icon alert-warning',
              content: this.translate.instant('IMPORT_FAILED_COUNT') + res.data.fail,
            }

            this.message = {
              class: 'alert dark alert-icon alert-success',
              content: this.translate.instant('IMPORT_PRODUCT_SUCCESS'),
            };
            setTimeout(() => {
              this.currentPage = 1;
              this.getStasitic();
              this.loadData(this.current_filter, this.sort);
            }, 1000);
          } else {
            this.message = {
              class: 'alert dark alert-icon alert-danger',
              content: res.message
            }
              ;
          }
        }, error => {
          this.message = {
            class: 'alert dark alert-icon alert-danger',
            content: error.message
          };
        });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: this.translate.instant('PLEASE_SELECT_EXCEL_FILE')
        };
      }
    } else {
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('UNSELECTED_FILE_IMPORT')
      };
    }
    this.clearInputUpdateFile()
  }

  /***Tuanba:17-11-2022: Export sản phẩm **/

  public messageExport = ''

  exportProduct(data) {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    console.log('data', data)
    const data_filter: any = {}
    data_filter.name = data.name || '';
    data_filter.sku = data.sku || '';
    data_filter.status = $('#status').val() || '';
    data_filter.sort_by = this.sort.field + ':' + this.sort.typeSort;
    const body = {
      exportTypeEnum: 'PRODUCT',
      fields: data_filter
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('SYSTEM_PROCESSING_FILE');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

  // === Tab nhắc nhở functions ===

  getAlertRepeatTime() {
    let opt: any = {};
    opt.offset = this.warningPage_Size * (this.currentPageRepeatTime - 1);
    opt.limit = this.warningPage_Size;
    let day_ago = $('#day-ago-product').val();
    if (day_ago) {
      opt.day_ago = day_ago;
    }
    if (this.productId5) {
      opt.product_id = this.productId5;
    }
    if (this.warningFilter.serial) {
      opt.serial = this.warningFilter.serial;
    }

    this.statisticService
      .getAlertRepeatTimeList(opt)
      .toPromise()
      .then((res) => {
        if (!res.error) {
          let length = res.data.total.total;
          let totalPage = Math.ceil(length / this.warningPage_Size);
          this.totalWarningPageRepeatTime = totalPage;
          this.listAlertRepeatTime = res.data.list.map((item: any) => {
            let tmpItem = item;
            let serialNumber = ('000000' + item.number.toString()).substring(
              ('000000' + item.number.toString()).length - 6
            );
            item.serial = tmpItem.prefix + '-' + serialNumber;
            return tmpItem;
          });
        }
      });
  }

  filterAlertRepeatTime() {
    this.currentPageRepeatTime = 1;
    this.getAlertRepeatTime();
  }

  setWarningPageRepeatTime(page: number) {
    if (page <= this.totalWarningPageRepeatTime) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalWarningPageRepeatTime) {
        page = this.totalWarningPageRepeatTime;
      }
      if (page != this.currentPageRepeatTime) {
        this.currentPageRepeatTime = page;
        this.getAlertRepeatTime();
      }
    } else {
      page = this.totalWarningPageRepeatTime;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_NHAC_NHO'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputPageRepeatProduct').val(1);
        this.currentPageRepeatTime = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_CANH_BAO_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalWarningPageRepeatTime) {
          page = this.totalWarningPageRepeatTime;
        }
        $('#inputPageRepeatProduct').val(page);
        if (page != this.currentPageRepeatTime) {
          this.currentPageRepeatTime = page;
          this.getAlertRepeatTime();
        }
      }
    }
  }

  goWarningPage2RepeatTime(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setWarningPageRepeatTime(toPage);
    }
  }

  changeProduct5(event) {
    this.productId5 = event ? event : null;
  }

  changeProduct5Label(event) {
    $('.value span').text(event);
  }

  resetReminder() {
    this.warningFilter = {};
    this.productId5 = null;
    $('.value span').text(this.translate.instant('SAN_PHAM'));
    $('.clear').hide();
    $('#day-ago-product').val(null).trigger('change');
    this.currentPageRepeatTime = 1;
    this.getAlertRepeatTime();
  }

  viewCustomer(customer_name: any) {
    if (customer_name) {
      this.router.navigate(['/qrcode/customer/list'], {
        queryParams: { customer_name: customer_name },
      });
    } else {
      return;
    }
  }

  initSelect2DayAgo() {
    this.translate.get('SO_NGAY_TRUOC').subscribe((res: string) => {
      $('#day-ago-product').select2({ placeholder: res, width: '100%', allowClear: true });
    });
  }

  // === Tab Cảnh báo sản phẩm hết hạn functions ===

  getWarningUseTime() {
    let data: any = {};
    data.offset = this.warningPage_Size * (this.currentPageUseTime - 1);
    data.limit = this.warningPage_Size;
    data.sort_by = 'ins_dt:desc';
    data.type = 2;

    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }
    if (this.productId4) {
      data.product_id = this.productId4;
    }
    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format('YYYY-MM-DD');
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format('YYYY-MM-DD');
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }

    this.statisticService
      .getDashboardWarningUseTime(data)
      .toPromise()
      .then((res) => {
        if (!res.error) {
          this.warningsUseTime = res.data.logs || [];
          let item = res.data.total;
          let totalPage = Math.ceil(item / this.warningPage_Size);
          this.totalWarningPageUseTime = totalPage;
        }
      })
      .catch((err) => {
        this.toastr.error(err.message);
      });
  }

  filterWarningUseTime() {
    this.currentPageUseTime = 1;
    this.getWarningUseTime();
  }

  setWarningPageUseTime(page: number) {
    if (page <= this.totalWarningPageUseTime) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalWarningPageUseTime) {
        page = this.totalWarningPageUseTime;
      }
      if (page != this.currentPageUseTime) {
        this.currentPageUseTime = page;
        this.getWarningUseTime();
      }
    } else {
      page = this.totalWarningPageUseTime;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_CANH_BAO_HET_HAN'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputPageUseTimeProduct').val(1);
        this.currentPageUseTime = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_CANH_BAO_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalWarningPageUseTime) {
          page = this.totalWarningPageUseTime;
        }
        $('#inputPageUseTimeProduct').val(page);
        if (page != this.currentPageUseTime) {
          this.currentPageUseTime = page;
          this.getWarningUseTime();
        }
      }
    }
  }

  goWarningPage2UseTime(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setWarningPageUseTime(toPage);
    }
  }

  changeProduct4(event) {
    this.productId4 = event ? event : null;
  }

  changeProduct4Label(event) {
    $('.value span').text(event);
  }

  resetWarningUseTime() {
    this.warningFilter.serial = null;
    this.warningFilter.from = null;
    this.warningFilter.to = null;
    this.productId4 = null;
    $('.value span').text(this.translate.instant('SAN_PHAM'));
    $('.clear').hide();
    $('#outdate-serial-product-usetime').val(null).trigger('change');
    $('#outdate_active_day_product').val(null).trigger('change');
    $('#outdate_dead_day_product').val(null).trigger('change');
    this.currentPageUseTime = 1;
    this.getWarningUseTime();
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product_list.component.ts